<template>
  <div class="top flex align-items-center justify-content-between">
    <van-steps :active="step" finish-icon="checked" inactive-icon="more" active-color="#D89A26" class="white-step">
      <van-step class="bg_trans">身份认证</van-step>
      <van-step class="bg_trans">影像认证</van-step>
      <van-step class="bg_trans">完善信息</van-step>
    </van-steps>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="less" scoped>
  .top {
    width: 100%;
    .step {
      width: 100%;
      img {
        width: 14px;
        height: 14px;
      }
    }
    .white-step {
      width: 100%;
      // background-color: rgba(0, 0, 0, 0);
    }
  }
</style>